export const MAX_ATTACHMENT_BYTES = 20 * 1024 * 1024;

export const ATTACHMENT_WARNING_RATIO = 0.8;

export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.jpg',
  '.jpeg',
  '.png',
  '.txt',
] as const;

export const ALLOWED_ATTACHMENT_ACCEPT_STRING = ALLOWED_ATTACHMENT_EXTENSIONS.join(',');

export const ALLOWED_ATTACHMENT_EXTENSIONS_PATTERN = new RegExp(
  `(${ALLOWED_ATTACHMENT_EXTENSIONS.map((ext) => ext.replace('.', '\\.')).join('|')})$`,
  'i',
);

/**
 * Max size for a file attachment uploaded via the file API (POST /slab/files/signedurl).
 * Distinct from MAX_ATTACHMENT_BYTES above, which is the email-attachment cap.
 */
export const MAX_FILE_ATTACHMENT_BYTES = 100 * 1024 * 1024;

/** Union of the allowed attachment extensions, derived from the source array. */
export type AllowedAttachmentExtension = (typeof ALLOWED_ATTACHMENT_EXTENSIONS)[number];

export const PRICE_ESCALATION_PERCENTAGE_MAX_INTEGER_DIGITS = 4;

export const PRICE_ESCALATION_MAX_CHANGE_RATIO = 99.999;
